import { TreeLevel } from 'components/DependencyTrees/CustomTreeLevel';
import { ReportItem } from 'store/ducks/Reporting/types';

export const businessProcessLevels: TreeLevel<ReportItem>[] = [
  {
    groupBy: (i) => String(i.business_process_l4_id),
    getKey: (group) => `bp-${group}`,
    getLabel: (i) => i.business_process_l4_title
  },
  {
    groupBy: (i) => i.risk_title ?? '-',
    getKey: (group) => `risk-${group}`,
    getLabel: (i) => i.risk_title ?? '-'
  },
  {
    groupBy: (i) => String(i.control_id),
    getKey: (group) => `control-${group}`,
    getLabel: (i) => i.control_name ?? '-'
  }
];

export const labelsBPR = ['BUSINESS PROCESS', 'RISK', 'CONTROL'] as const;
